import React from 'react';

type State = NotificationPermission | 'unsupported';

const read = (): State => (typeof window !== 'undefined' && 'Notification' in window ? Notification.permission : 'unsupported');

export function useNotificationPermission(): State {
    const [state, setState] = React.useState<State>(read);

    React.useEffect(() => {
        if (read() === 'unsupported') return undefined;
        const refresh = () => setState(read());
        let status: PermissionStatus | null = null;
        navigator.permissions?.query({ name: 'notifications' as PermissionName }).then((result) => {
            status = result;
            result.onchange = refresh;
        }).catch(() => undefined);
        window.addEventListener('focus', refresh);
        document.addEventListener('visibilitychange', refresh);
        return () => {
            if (status) status.onchange = null;
            window.removeEventListener('focus', refresh);
            document.removeEventListener('visibilitychange', refresh);
        };
    }, []);

    return state;
}

export default useNotificationPermission;
